'use strict';

var toastr = require('toastr');
var GridRejectHostShareButtonController = function GridRejectHostShareButtonController($scope, hepService) {
  var gridPanel = $scope.gridPanelScope.$parent;
  $scope.rejectHostShare = function () {
    hepService.rejectNPS(gridPanel.getSelectedRows()).then(function () {
      toastr.success('Successfully Rejected.');
      gridPanel.refreshGridButtonHandler();
    }, function () {
      toastr.error('Error in Rejecting');
    });
  };
  $scope.setRejectButtonState = function (evt, isRowSelected) {
    $scope.isRejectButtonEnable = isRowSelected;
  };
};
GridRejectHostShareButtonController.$inject = ['$scope', 'HepService'];
module.exports = GridRejectHostShareButtonController;